<template>
  <div class="section">
    <div class="header">
      <span>利润总览</span>
    </div>
    <div class="main">
      <div class="left">
        <div class="item">
          <img class="icon" src="@/assets/img/operate/xmys.png" />
          <div class="content">
            <span class="label">项目利润（万元）</span>
            <div class="value">
              <span class="val">{{ formatNumber(details.actualProfitAmount) }}</span>
            </div>
            <span class="label">较计划/评估</span>
            <div class="value">
              <span class="val">{{ Math.abs(formatNumber(details.actualToPlanProfitAmount)) }}</span>
              <img v-if="details.actualToPlanProfitAmount > 0" src="@/assets/img/operate/up.png" />
              <img v-if="details.actualToPlanProfitAmount < 0" src="@/assets/img/operate/down.png" />
            </div>
          </div>
        </div>
        <div class="item2">
          <div class="line1">
            <img class="icon" src="@/assets/img/operate/tb.png" />
            <span class="label">实际平均利润率</span>
          </div>
          <div class="chart-content" id="chart6"></div>
        </div>
      </div>
      <div class="right">
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">月度利润对比分析</span>
          </div>
          <div class="chart-content" id="chart7"></div>
        </div>
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">项目利润率排行</span>
          </div>
          <div class="chart-content" id="chart8"></div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible1" title="项目利润">
      <el-form inline>
        <el-form-item>
          {{ currentName }}
        </el-form-item>
      </el-form>
      <el-table :data="tableData1">
        <el-table-column prop="ym" label="月份" />
        <el-table-column prop="actualProfitAmount" label="实际利润（元）" />
        <el-table-column prop="planProfitAmount" label="计划利润（元）" />
        <el-table-column prop="actualToPlanProfitAmount" label="偏差额" />
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" title="月度利润对比">
      <el-form inline>
        <el-form-item>
          {{ currentName }}
        </el-form-item>
      </el-form>
      <el-table :data="tableData2">
        <el-table-column prop="projectName" label="项目名称" />
        <el-table-column prop="actualProfitAmount" label="实际利润（元）" />
        <el-table-column prop="planProfitAmount" label="计划利润（元）" />
        <el-table-column prop="actualToPlanProfitAmount" label="偏差额" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
export default {
  name: 'Overview3',
  mixins: [chartMixin],
  data() {
    return {
      currentName: '',
      dialogVisible1: false,
      dialogVisible2: false,
      tableData1: [],
      tableData2: [],
      searchForm: {
        startTime: '', // 开始日期
        endTime: '' // 结束日期
      },
      details: {
        ymList: [], // 年月列表
        actualProfitAvgPer: '', // 实际利润平均率
        actualProfitAmount: '', // 实际利润金额
        planProfitAmount: '', // 计划利润金额
        actualProfitAmountList: [], // 实际利润金额列表
        actualToPlanProfitAmount: '', // 实际较计划利润差值金额
        planProfitAmountList: [], // 计划利润金额列表
        projectNameList: [], // 利润率项目名称列表
        actualProfitPerList: [] // 利润率值列表
      }
    }
  },
  created() {
    this.$event.$on('yearMonthChange', this.loadData)
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  beforeDestroy() {
    this.$event.$off('yearMonthChange')
  },
  watch: {
  },
  methods: {
    formatNumber(num) {
      // 检查输入是否为数字
      if (!num) {
        return '--'
      }
      // 除以 10000 并保留三位小数
      const result = (num / 10000).toFixed(3);
      // 返回结果（注意：toFixed 返回的是字符串，如果需要数字可以转换）
      return parseFloat(result);
    },
    loadData(searchForm) {
      this.searchForm = searchForm
      this.$axios.get(this.$apis.operate.selectProfit, searchForm).then(res => {
        this.details = res || {}
        this.initChart6()
        this.initChart7()
        this.initChart8()
      })
    },
    initChart6() {
      const chart = this.$getChartInstance('#chart6')
      if (!chart) return;
      const option = {
        title: {
          text: this.details.actualProfitAvgPer + '%',
          left: 'center',
          top: 'middle'
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false
        },
        color: ['#40557D', '#289DF5'],
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 0
            },
            label: {
              show: false,
              position: 'center'
            },
            data: [
              { value: 100 - this.details.actualProfitAvgPer, name: '其他' },
              { value: this.details.actualProfitAvgPer, name: '实际' }
            ]
          }
        ]
      };
      chart.clear()
      chart.setOption(option)
    },
    initChart7() {
      const chart = this.$getChartInstance('#chart7')
      if (!chart) return;
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.details.ymList,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#346EB1',
            },
            data: this.details.planProfitAmountList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#FAD961' }, // 起始颜色
                { offset: 0, color: '#FF8C4A' } // 结束颜色
              ]),
            },
            data: this.details.actualProfitAmountList
          }
        ],
        dataZoom: {
          show: this.details.ymList.length > 5,
          type: 'slider',
          borderColor: 'transparent',
          backgroundColor: '#D9D9D9',
          fillerColor: '#2275D3',
          handleStyle: {
            opacity: 0
          },
          bottom: 10,
          height: 6,
          start: 0,
          end: 50,
          showDetail: false,
          showDataShadow: false,
          brushSelect: false
        }
      }
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
          const yearMonth = this.details.ymList[index]
          this.currentName = yearMonth
          this.selectProfitMonthVs(yearMonth)
          this.dialogVisible2 = true
        }
      })
    },
    initChart8() {
      const chart = this.$getChartInstance('#chart8')
      if (!chart) return;
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '%<br>';
            }
            return tooltipStr;
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        xAxis: {
          show: false
        },
        yAxis: {
          type: 'category',
          data: this.details.projectNameList,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '占比',
            type: 'bar',
            showBackground: true,
            barWidth: 24,
            color: '#2297F0',
            data: this.details.actualProfitPerList
          }
        ]
      };
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1]
          const projectName = this.details.projectNameList[index]
          this.currentName = projectName
          this.selectProfitProjectVs(projectName)
          this.dialogVisible1 = true
        }
      })
    },
    selectProfitMonthVs(yearMonth) {
      this.$axios.get(this.$apis.operate.selectProfitMonthVs, {
        yearMonth
      }).then(res => {
        this.tableData2 = res || []
      })
    },
    selectProfitProjectVs(projectName) {
      const item = this.projectList.find(item => item.projectName === projectName)
      this.$axios.get(this.$apis.operate.selectProfitProjectVs, {
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        projectId: item.projectId
      }).then(res => {
        this.tableData1 = res || []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section {
  height: 570px;
  background: #FFFFFF;
  border-radius: 2px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  &.total {
    height: 392px;
    margin-top: 50px;
  }

  .header {
    height: 60px;
    border-bottom: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
    padding: 0 24px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .main {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 60px;

    .left {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          .value {
            display: flex;
            align-items: flex-end;
            align-items: center;
            margin-top: 16px;
            margin-bottom: 16px;

            span {
              &.yuan {
                font-size: 20px;
                margin-right: 10px;
                line-height: 32px;
              }

              &.val {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #354052;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }

          .desc {
            display: flex;
            align-items: center;
            margin-top: 20px;

            span {
              &:nth-child(1) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #7F8FA4;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }

              &:nth-child(2) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #354052;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-left: 10px;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }
        }
      }

      .item2 {
        display: flex;
        flex-direction: column;
        height: 250px;

        .line1 {
          display: flex;
          align-items: center;

          img {
            margin-right: 16px;
          }

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .chart-content {
          width: 250px;
          height: 250px;
          margin-top: 10px;
        }
      }
    }

    .right {
      flex: 1;
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 90px;

      .chart-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-top: 49px;

        &:nth-child(n + 2) {
          margin-left: 60px;
        }

        .chart-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .chart-content {
          flex: 1;
          padding-top: 40px;
        }
      }
    }
  }
}
</style>
